import NavigationLayout from '../../Layouts/NavigationLayout';
import MarketplaceRedirect from './scenes/MarketplaceRedirect';

export const marketplaceRoutes = [
    {
        layout: NavigationLayout,
        path: '/marketplace/:orgUuidOrSlug',
        component: MarketplaceRedirect,
        private: true,
        exact: true,
    },
    {
        layout: NavigationLayout,
        path: '/marketplace/:orgUuidOrSlug/:itemId',
        component: MarketplaceRedirect,
        private: true,
    },
];
